import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import Content from './content';
import Header from './header';
const DealsListSkeleton = () => _jsxs(Fragment, { children: [_jsx(Header, { "data-sentry-element": "Header", "data-sentry-source-file": "index.tsx" }), _jsx(Content, { "data-sentry-element": "Content", "data-sentry-source-file": "index.tsx" })] });
export default DealsListSkeleton;
